import { validatePresence, validateLength } from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence({ message: 'content_pillars.validations.ideas.title.presence', presence: true }),
    validateLength({ message: 'content_pillars.validations.ideas.title.length', min: 3, max: 200 })
  ]
};
